import { useProductSelector } from 'src/hooks/api/selectors/useProductSelector';
import { getBoardLinkSectionName } from 'src/utils/viewSection.utils';

export const useBoardLinkSectionName = (boardId: string | null | undefined) => {
  return useProductSelector(product => getBoardLinkSectionName(boardId, product));
};
